import type { ApprovalMode, AttachmentBlock } from '../../contracts/harness.types';
import type { LinkedContextItem } from '../../contracts/projects/linked-context';
import { composerUploadMetadataToBlocks } from '../../contracts/projects/projectOptimisticAttachments';
import type { WorkCreateCommand } from './Composer';
import {
  composerAttachmentFiles,
  composerUploadedAttachmentMetadata,
} from './composer-attachments';

export type SeededFirstTurn = {
  prompt: string;
  displayPrompt?: string;
  files: File[];
  attachment_ids?: string[];
  optimisticAttachments?: AttachmentBlock[];
  linked: LinkedContextItem | null;
  approvalMode?: ApprovalMode;
};

export const seededFirstTurnFromCommand = (
  command: WorkCreateCommand
): SeededFirstTurn => {
  const uploaded = composerUploadedAttachmentMetadata(command.attachments);
  const attachmentIds =
    uploaded.length > 0 ? uploaded.map((item) => item.attachment_id) : undefined;
  const prompt = command.text.trim();
  const displayPrompt = command.displayText.trim();
  return {
    prompt,
    ...(displayPrompt && displayPrompt !== prompt ? { displayPrompt } : {}),
    files: composerAttachmentFiles(command.attachments),
    ...(attachmentIds
      ? {
          attachment_ids: attachmentIds,
          optimisticAttachments: composerUploadMetadataToBlocks(uploaded),
        }
      : {}),
    linked: command.linkedContext[0] ?? null,
    ...(command.approvalMode ? { approvalMode: command.approvalMode } : {}),
  };
};

export const seededFirstTurnIsEmpty = (turn: SeededFirstTurn): boolean =>
  !turn.prompt && turn.files.length === 0 && !turn.attachment_ids?.length;
